<template>
  <div class="about">
    <v-layout row wrap justify-center class="mt-5">
      <h1 class="heading" style="color: #6B3689">{{ pageTitle }}</h1>
    </v-layout>
    <v-container>
      <v-layout row wrap>
        <v-card class="mx-auto" color="#946EA9" dark >
          <v-card-title>
            <v-icon large left>camera_alt</v-icon>
            <span class="title font-weight-light">Fotowettbewerb</span>
          </v-card-title>

          <v-card-text class="headline">
            Liebe Gemeindeglieder, <br>liebe Möhrendorferinnen und Möhrendorfer,
            <br><br>aktuell gibt es ein wunderbares Motto für die Fastenzeit seitens unserer evangelischen Kirche: „Zuversicht – 7 Wochen ohne Pessimismus“.
            <br>Diese Zuversicht wollen wir gerne „sehen“ können – nämlich mit Ihrer/eurer Hilfe.
            <br><br>Und das geht so:
          </v-card-text>
          <v-card-text class="headline font-weight-bold">
            Macht bitte Fotos, die Zuversicht ausstrahlen!
          </v-card-text>
          <v-card-text class="headline">
            Das Motiv kann unterschiedlich sein: Natur, Gebäude, draußen, drinnen, …. etc. – Eurer Fantasie sind keine Grenzen gesetzt.
            <br>Tragt dann bitte eure Fotos hier bei, damit noch mehr Menschen Freude daran haben können.
            <br>Erster (und einziger ;-) ) Preis: Das zuversichtlichste Foto wird unseren nächsten Gemeindebrief auf seiner ersten Seite zieren.
            <br>Andere, schöne Bilder möchten wir gerne in Fotoalben zusammenstellen.
            <br><br>Also: Bitte ran uns Smartphone oder die Kamera und ordentlich knipsen!
            <br>Teilt eure Zuversicht mit uns.
            <br><br>Ein Herzliches Dankeschön und bleibt behütet!
          </v-card-text>
          <v-card-actions>
            <v-list-item class="grow">
              <v-list-item-avatar color="grey darken-3">
                <v-img
                  class="elevation-6"
                  src="https://firebasestorage.googleapis.com/v0/b/zuversicht.appspot.com/o/Volker_Metzler_Pfarramt3.jpg?alt=media&token=86c1bf18-0d0b-438c-93ff-5914a2d41e43"
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Dr. Volker Metzler - Pfarrer</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
      pageTitle: 'Worum gehts?'
    }
  }
}
</script>

<style>
</style>
